import { listReport } from './ClientDeviceByDay/ClientDevice.i18n.en'

export const clientDevice = {
  listReport,
}
